import React, { useEffect, useState } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import AddressForm from "./AddressForm";

const AddBranch = ({ validation, warehouseList = [], taxIdentities = [] }) => {
  const gstIdentities = taxIdentities?.filter((ele) => ele.taxType === 'GST');
  const panIdentities = taxIdentities?.filter((ele) => ele.taxType === 'PAN');

  return (
    <>
      <Row>
        <Col>
          <FormGroup>
            <Label className="col-form-label">Branch Name</Label>
            <Input
              className="form-control"
              type="text"
              placeholder="Enter Branch Name"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation?.values?.primaryBranch?.name || ""}
              name="primaryBranch.name"
              invalid={
                validation?.touched?.primaryBranch?.name &&
                validation?.errors?.primaryBranch?.name
              }
            />
            {validation?.touched?.primaryBranch?.name &&
              validation?.errors?.primaryBranch?.name ? (
              <p style={{ color: "red" }}>
                {validation.errors?.primaryBranch?.name}
              </p>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <label className="col-form-label">Associated Warehouse</label>
            <select
              name="primaryBranch.associatedWarehouse"
              id="associatedWarehouse"
              className="form-select focus-width"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation?.values?.primaryBranch?.associatedWarehouse || ""}
              invalid={
                
                validation?.touched?.primaryBranch?.associatedWarehouse &&
                validation?.errors?.primaryBranch?.associatedWarehouse
              }
            >
              <option value="" disabled>Select Associated Warehouse</option>
              {warehouseList.map((e) => (
                <option value={e._id}>{e.code}</option>
              ))}
            </select>
            {validation?.touched?.primaryBranch?.associatedWarehouse &&
              validation?.errors?.primaryBranch?.associatedWarehouse ? (
              <p style={{ color: "red" }}>
                {validation?.errors?.primaryBranch?.associatedWarehouse}
              </p>
            ) : null}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <label className="item-name">Branch Contact Number</label>
            <Input
              name="primaryBranch.contact"
              id="contact"
              className="form-control"
              inputMode="numeric"   
              pattern="[0-9]*"    
              type="text"  
              maxLength="10"
              placeholder="Enter Branch Contact Number"
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); 
                validation.setFieldValue("primaryBranch.contact", value);
              }}
              onBlur={validation.handleBlur}
              value={validation?.values?.primaryBranch?.contact || ""}
              invalid={
                validation?.touched?.primaryBranch?.contact &&
                validation?.errors?.primaryBranch?.contact
              }
            />
            {validation?.touched?.primaryBranch?.contact &&
              validation?.errors?.primaryBranch?.contact ? (
              <p style={{ color: "red" }}>
                {validation?.errors?.primaryBranch?.contact}
              </p>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
        <FormGroup>
            <label className="item-name">Branch Code</label>
            <Input
              name="primaryBranch.code"
              id="code"
              className="form-control"
              type="text"
              placeholder="Enter Branch Code"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              maxLength={10}
              value={validation?.values?.primaryBranch?.code || ""}
              invalid={
                validation?.touched?.primaryBranch?.code &&
                validation?.errors?.primaryBranch?.code
              }
            />
            {validation?.touched?.primaryBranch?.code &&
              validation?.errors?.primaryBranch?.code ? (
              <p style={{ color: "red" }}>
                {validation?.errors?.primaryBranch?.code}
              </p>
            ) : null}
        </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <label className="item-name">Zoho Address Id</label>
            <Input
              name="primaryBranch.zohoAddressId"
              id="zohoAddressId"
              className="form-control"
              type="text"
              placeholder="Enter Zoho Address Id"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation?.values?.primaryBranch?.zohoAddressId || ""}
              invalid={
                validation?.touched?.primaryBranch?.zohoAddressId &&
                validation?.errors?.primaryBranch?.zohoAddressId
              }
            />
            {validation?.touched?.primaryBranch?.zohoAddressId &&
              validation?.errors?.primaryBranch?.zohoAddressId ? (
              <p style={{ color: "red" }}>
                {validation?.errors?.primaryBranch?.zohoAddressId}
              </p>
            ) : null}
          </FormGroup>
        </Col>
      </Row>
      <Row>
      {gstIdentities?.length > 0 && (
      <Col>
        <Label>Select GST</Label>
        <Input
          type="select"
          name={`primaryBranch.gstin`}
          value={validation?.values?.primaryBranch?.gstin}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          invalid={validation?.touched?.primaryBranch?.gstin && validation?.errors?.primaryBranch?.gstin}
        >
          <option value="">Select GST</option>
          {gstIdentities.map((tax) => (
            <option key={tax._id} value={tax._id}>
              {tax.taxRegistrationNumber}
            </option>
          ))}
        </Input>
        {validation?.touched?.primaryBranch?.gstin && validation?.errors?.primaryBranch?.gstin && (
          <p style={{ color: "red" }}>
            {validation.errors?.primaryBranch?.gstin}
          </p>
        )}

        </Col>
        )}
        {panIdentities?.length > 0 && (
        <Col>
        <Label>Select PAN</Label>
        <Input
          type="select"
          name={`primaryBranch.pan`}
          value={validation?.values?.primaryBranch?.pan}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          invalid={validation?.touched?.primaryBranch?.pan && validation?.errors?.primaryBranch?.pan}
        >
          <option value="">Select PAN</option>
          {panIdentities.map((tax) => (
            <option key={tax._id} value={tax._id}>
              {tax.taxRegistrationNumber}
            </option>
          ))}
        </Input>
        {validation?.touched?.primaryBranch?.pan && validation?.errors?.primaryBranch?.pan && (
          <p style={{ color: "red" }}>
            {validation.errors?.primaryBranch?.pan}
          </p>
        )}
        </Col>
        )}
      </Row>
      <AddressForm validation={validation} fieldPath="primaryBranch" />
    </>
  );
};

export default AddBranch;
